export const GENDER_OPTIONS = [
  { label: 'Man', value: 'man' },
  { label: 'Woman', value: 'woman' },
  { label: 'Non-binary', value: 'non-binary' },
  { label: 'Prefer not to say', value: 'not-specified' }
];

export const CONSTRAINT_OPTIONS = [
  { label: 'Yes, this reflects what I actually want', value: 'reflects' },
  { label: 'Not entirely — my situation limits me', value: 'limited' }
];

export const KINSEY_QUESTIONS = [
  {
    id: 'q1',
    category: 'attraction',
    timeframe: 'present',
    text: 'Right now, who are you most attracted to?',
    options: [
      { label: 'Only women', value: 0 },
      { label: 'Mostly women', value: 1 },
      { label: 'Both, but more women', value: 2 },
      { label: 'Both equally', value: 3 },
      { label: 'Both, but more men', value: 4 },
      { label: 'Mostly men', value: 5 },
      { label: 'Only men', value: 6 }
    ]
  },
  {
    id: 'q2',
    category: 'attraction',
    timeframe: 'past',
    text: 'Looking back, who were you most attracted to?',
    options: [
      { label: 'Only women', value: 0 },
      { label: 'Mostly women', value: 1 },
      { label: 'Both, but more women', value: 2 },
      { label: 'Both equally', value: 3 },
      { label: 'Both, but more men', value: 4 },
      { label: 'Mostly men', value: 5 },
      { label: 'Only men', value: 6 }
    ]
  },
  {
    id: 'q3',
    category: 'fantasy',
    timeframe: 'present',
    text: 'Who do you think about when you fantasize?',
    options: [
      { label: 'Only women', value: 0 },
      { label: 'Mostly women', value: 1 },
      { label: 'Both, but more women', value: 2 },
      { label: 'Both equally', value: 3 },
      { label: 'Both, but more men', value: 4 },
      { label: 'Mostly men', value: 5 },
      { label: 'Only men', value: 6 }
    ]
  },
  {
    id: 'q4',
    category: 'fantasy',
    timeframe: 'past',
    text: 'Looking back, who did you usually fantasize about?',
    options: [
      { label: 'Only women', value: 0 },
      { label: 'Mostly women', value: 1 },
      { label: 'Both, but more women', value: 2 },
      { label: 'Both equally', value: 3 },
      { label: 'Both, but more men', value: 4 },
      { label: 'Mostly men', value: 5 },
      { label: 'Only men', value: 6 }
    ]
  },
  {
    id: 'q5',
    category: 'behavior',
    timeframe: 'present',
    hasConstraint: true,
    text: 'Recently, who have you been with most — and does that reflect what you actually want?',
    options: [
      { label: 'Only women', value: 0 },
      { label: 'Mostly women', value: 1 },
      { label: 'Both, but more women', value: 2 },
      { label: 'Both equally', value: 3 },
      { label: 'Both, but more men', value: 4 },
      { label: 'Mostly men', value: 5 },
      { label: 'Only men', value: 6 },
      { label: 'No one recently', value: null }
    ]
  },
  {
    id: 'q6',
    category: 'behavior',
    timeframe: 'past',
    hasConstraint: true,
    text: 'In the past, who were you with — and did that reflect what you actually wanted?',
    options: [
      { label: 'Only women', value: 0 },
      { label: 'Mostly women', value: 1 },
      { label: 'Both, but more women', value: 2 },
      { label: 'Both equally', value: 3 },
      { label: 'Both, but more men', value: 4 },
      { label: 'Mostly men', value: 5 },
      { label: 'Only men', value: 6 },
      { label: 'No one at that point', value: null }
    ]
  },
  {
    id: 'q7',
    category: 'stability',
    timeframe: null,
    text: 'Has this changed much over time?',
    options: [
      { label: 'No, it has been pretty consistent', value: 'consistent' },
      { label: 'A little, but mostly the same', value: 'somewhat' },
      { label: 'Yes, it has shifted noticeably', value: 'shifted' },
      { label: 'Still figuring it out', value: 'evolving' }
    ]
  },
  {
    id: 'q8',
    category: 'direction',
    timeframe: null,
    text: 'If it is changing, which way does it seem to be going?',
    options: [
      { label: 'More toward women', value: 'toward-women' },
      { label: 'Staying about the same', value: 'same' },
      { label: 'More toward men', value: 'toward-men' },
      { label: 'Not sure', value: 'unsure' }
    ]
  },
  {
    id: 'q9',
    category: 'confidence',
    timeframe: null,
    text: 'How sure are you about this right now?',
    options: [
      { label: 'Very sure', value: 'very' },
      { label: 'Fairly sure', value: 'somewhat' },
      { label: 'Not very sure', value: 'not-very' },
      { label: 'Honestly not sure', value: 'unsure' }
    ]
  },
  {
    id: 'q10',
    category: 'self-reflection',
    timeframe: null,
    text: 'Which feels most true right now?',
    options: [
      { label: 'This reflects something I know well', value: 'known' },
      { label: 'This reflects something I am still exploring', value: 'exploring' }
    ]
  }
];

const weightedAvg = (attraction, fantasy, behavior, behaviorConstrained) => {
  let sum = 0;
  let weight = 0;
  const behaviorWeight = behaviorConstrained ? 0.05 : 0.2;

  if (attraction !== null) { sum += attraction * 0.4; weight += 0.4; }
  if (fantasy !== null) { sum += fantasy * 0.4; weight += 0.4; }
  if (behavior !== null) { sum += behavior * behaviorWeight; weight += behaviorWeight; }

  return weight > 0 ? Math.round((sum / weight) * 10) / 10 : null;
};

// Flip scored answers for women so 0=opposite-sex, 6=same-sex (traditional Kinsey)
const flipForGender = (val, gender) => {
  if (val === null || typeof val !== 'number') return val;
  return gender === 'woman' ? 6 - val : val;
};

export const calculateKinseyScore = (answers, gender) => {
  const g = gender || 'not-specified';

  const pastAttraction = typeof answers.q2 === 'number' ? flipForGender(answers.q2, g) : null;
  const pastFantasy = typeof answers.q4 === 'number' ? flipForGender(answers.q4, g) : null;
  const pastBehavior = typeof answers.q6 === 'number' ? flipForGender(answers.q6, g) : null;
  const pastConstrained = answers.q6_constraint === 'limited';

  const presentAttraction = typeof answers.q1 === 'number' ? flipForGender(answers.q1, g) : null;
  const presentFantasy = typeof answers.q3 === 'number' ? flipForGender(answers.q3, g) : null;
  const presentBehavior = typeof answers.q5 === 'number' ? flipForGender(answers.q5, g) : null;
  const presentConstrained = answers.q5_constraint === 'limited';

  const pastScore = weightedAvg(pastAttraction, pastFantasy, pastBehavior, pastConstrained);
  const presentScore = weightedAvg(presentAttraction, presentFantasy, presentBehavior, presentConstrained);

  const hasConstraint = presentConstrained || pastConstrained;

  let direction = 'stable';
  let directionLabel = 'Relatively stable';
  const diff = (presentScore !== null && pastScore !== null) ? presentScore - pastScore : 0;

  // Direction labels are gender-relative after flipping
  // For man/neutral: higher score = toward men. For woman: higher score = toward women.
  const towardHighLabel = g === 'woman' ? 'toward women' : 'toward men';
  const towardLowLabel = g === 'woman' ? 'toward men' : 'toward women';

  if (Math.abs(diff) >= 1) {
    if (diff > 0) { direction = `toward-${g === 'woman' ? 'women' : 'men'}`; directionLabel = `Shift ${towardHighLabel}`; }
    else { direction = `toward-${g === 'woman' ? 'men' : 'women'}`; directionLabel = `Shift ${towardLowLabel}`; }
  } else if (Math.abs(diff) >= 0.5) {
    if (diff > 0) { direction = `slight-toward-${g === 'woman' ? 'women' : 'men'}`; directionLabel = `Slight shift ${towardHighLabel}`; }
    else { direction = `slight-toward-${g === 'woman' ? 'men' : 'women'}`; directionLabel = `Slight shift ${towardLowLabel}`; }
  }

  const confidenceAnswer = answers.q9;
  const selfReflection = answers.q10;
  const stability = answers.q7;

  let confidenceScore = 0;
  if (confidenceAnswer === 'very') confidenceScore += 3;
  else if (confidenceAnswer === 'somewhat') confidenceScore += 2;
  else if (confidenceAnswer === 'not-very') confidenceScore += 1;
  if (selfReflection === 'known') confidenceScore += 2;
  else confidenceScore += 1;
  if (stability === 'consistent') confidenceScore += 2;
  else if (stability === 'somewhat') confidenceScore += 1;

  let confidence;
  if (confidenceScore >= 6) confidence = 'high';
  else if (confidenceScore >= 4) confidence = 'medium';
  else confidence = 'low';

  return {
    pastScore,
    presentScore,
    diff: Math.round(diff * 10) / 10,
    direction,
    directionLabel,
    confidence,
    stability,
    hasConstraint,
    presentConstrained,
    pastConstrained,
    selfDirectionAnswer: answers.q8,
    selfReflection
  };
};

// Gender-relative definition mappings
const DEFINITIONS_MAN = {
  0: 'Exclusively attracted to women',
  1: 'Primarily attracted to women, with only occasional attraction to men',
  2: 'Mostly attracted to women, but with meaningful attraction to men',
  3: 'Attracted to women and men about equally',
  4: 'Mostly attracted to men, but with meaningful attraction to women',
  5: 'Primarily attracted to men, with only occasional attraction to women',
  6: 'Exclusively attracted to men'
};

const DEFINITIONS_WOMAN = {
  0: 'Exclusively attracted to men',
  1: 'Primarily attracted to men, with only occasional attraction to women',
  2: 'Mostly attracted to men, but with meaningful attraction to women',
  3: 'Attracted to men and women about equally',
  4: 'Mostly attracted to women, but with meaningful attraction to men',
  5: 'Primarily attracted to women, with only occasional attraction to men',
  6: 'Exclusively attracted to women'
};

const DEFINITIONS_NEUTRAL = {
  0: 'Stronger attraction toward women',
  1: 'Mostly attracted to women, with some attraction to men',
  2: 'Attracted to both, leaning toward women',
  3: 'Attraction to both women and men',
  4: 'Attracted to both, leaning toward men',
  5: 'Mostly attracted to men, with some attraction to women',
  6: 'Stronger attraction toward men'
};

const getDefinitionsForGender = (gender) => {
  if (gender === 'man') return DEFINITIONS_MAN;
  if (gender === 'woman') return DEFINITIONS_WOMAN;
  return DEFINITIONS_NEUTRAL;
};

export const getKinseyDefinition = (score, gender) => {
  if (score === null) return null;
  const rounded = Math.max(0, Math.min(6, Math.round(score)));
  const defs = getDefinitionsForGender(gender || 'not-specified');
  return { category: rounded, definition: defs[rounded] };
};

export const getInterpretation = (score, gender) => {
  if (score === null) return 'Not enough data';
  const def = getKinseyDefinition(score, gender);
  return def ? def.definition : 'Not enough data';
};

export const getTimeInterpretation = (pastScore, presentScore, direction, gender) => {
  const pastText = getInterpretation(pastScore, gender);
  const presentText = getInterpretation(presentScore, gender);

  if (direction === 'stable') {
    return `Your attraction has stayed consistent over time. ${presentText}.`;
  }
  if (pastText === presentText) {
    return `Your overall pattern has stayed in the same range, though you may have noticed some shifts along the way.`;
  }
  return `Your attraction has shifted over time. Earlier: ${pastText.toLowerCase()}. Now: ${presentText.toLowerCase()}.`;
};

export const getDirectionInsight = (result) => {
  if (result.direction === 'stable') return 'This pattern has stayed pretty consistent.';
  const verb = result.direction.includes('toward-men') ? 'toward men' : 'toward women';
  const intensity = result.direction.includes('slight') ? 'subtle' : 'noticeable';
  return `This suggests your attraction has shifted over time, with a ${intensity} move ${verb}.`;
};

export const getConstraintInsight = (result) => {
  if (result.hasConstraint) {
    return 'Your real-life experiences may be influenced by your current situation. This means what you have done does not always fully reflect what you are drawn to.';
  }
  return 'Your real-life experiences appear to closely reflect your underlying attraction pattern.';
};

export const getConfidenceText = (confidence) => {
  if (confidence === 'high') return 'This pattern looks clear and well-defined.';
  if (confidence === 'medium') return 'There is some variation depending on context.';
  return 'This may still be evolving or something you are figuring out.';
};
